import { Directive, ElementRef, Input, OnInit, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
 @Directive({
 selector: '[highlighter]'
 })
 export class HighLightDirectives implements OnInit {
       @Input() target: string;
       @Input() searchText: string;
       constructor(private elementRef: ElementRef, private renderer: Renderer2, @Inject(DOCUMENT) private document) {
       }
      ngOnInit() {
        const child = document.createElement('span');
        child.innerHTML = this.target;

        if (this.target != undefined) {
          let str = this.target.replace(new RegExp(this.searchText.trim(), "gi"), (match) => `<span class='highlight'>${match}</span>`);
          child.innerHTML = str;
        }
        this.renderer.appendChild(this.elementRef.nativeElement, child);
      }
 }
